import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import axios from 'axios';
import Tooltip from '@material-ui/core/Tooltip';


import { Button, Card, CardHeader, CardBody, FormGroup, Input, InputGroupAddon, InputGroupText, InputGroup, Row, Col,} from "reactstrap";

const Login = (props) => {
    const location = useLocation();
    const history = useHistory();

    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const [code, setCode] = React.useState();

    if (location) {
        // console.log('yes location')
        // console.log(location);
        // console.log(location.state);
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.message);
                    setSendingdata(location.state.message);
                    settt(location.state.type);
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }
    }

    const [showpass1, setShowPass1] = React.useState(false);
    const [showpass2, setShowPass2] = React.useState(false);

    const [password, setPassword] = React.useState('');

    const [password2, setPassword2] = React.useState('');

    // const [type, setType] = React.useState('Username');
    // const [main, setMain] = React.useState();
    // var place = 'Enter ' + type
    // console.log(props.username)
    // console.log(props)
    const handleChangeU = (event) => {
        if (event.target.value === location.state.['code']) {
            event.target.style.backgroundColor = 'lightgreen';
            event.target.style.color = 'black';
            setCode('right');
        }
        else {
            event.target.style.backgroundColor = '';
            setCode('wrong');
        }
    };
    const handleChangeP1 = (event) => {
        setPassword(event.target.value)
    };
    const handleChangeP2 = (event) => {
        setPassword2(event.target.value)
    };
    const handleClickShowPassword1 = () => {
        if (showpass1 === false) {
            setShowPass1(true);
        }
        else {
            setShowPass1(false)
        }
    };
    const handleClickShowPassword2 = () => {
        if (showpass2 === false) {
            setShowPass2(true);
        }
        else {
            setShowPass2(false)
        }
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            loginPageHandler();
        }
    };
    const loginPageHandler = () => {
        if (password === undefined) {
            setSendingdata('Please Enter the credentials properly')
            settt('error');
            setOpen(true);
            return 0;
        }
        if (password.length < 1) {
            setSendingdata('Please Enter the credentials properly')
            settt('error');
            setOpen(true);
            return 0;
        }
        if (password !== password2) {
            setSendingdata('Passwords do not match')
            settt('error');
            setOpen(true);
            return 0;
        }
        if(code==='right'){
            setSendingdata('Please wait a sec')
            settt('success');
            setOpen(true);
            var inp = {
                'id': location.state.user,
                'old': password,
                'new': password2
            }
            // console.log(inp)
            axios.post(process.env.REACT_APP_DOMAIN+'/confirmpassword', inp)
                .then((response) => {
                    // console.log(response.data)
                    history.push({
                        pathname: '/auth/login',
                        state: response.data
                    })
                })
                .catch((error) => {
                    setSendingdata('Something Went Wrong')
                    settt('error');
                    setOpen(true);
                })    
        }
        else {
            setSendingdata('Wrong Verification code')
            settt('error');
            setOpen(true);
            return 0;
        }
    };
    return (
        <>
            <Col lg="15" md="7">
                <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-5">
                        <div className="btn-wrapper text-center">
                            <Button
                                className="btn-neutral btn-icon"
                                color="default"
                                href="#pablo"
                                onClick={(e) => e.preventDefault()}
                            >
                                <span className="btn-inner--icon">
                                    <img
                                        alt="..."
                                        src={
                                            require("../../assets/img/kj.png")
                                                .default
                                        }
                                    />
                                </span>
                                <span className="btn-inner--text">Confirm Password</span>
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        <Row className="row">
                            <Col className="" sm={12} lg={12}>
                                <FormGroup className="mb-3">
                                    <Tooltip title={(code === 'right' ? 'Verification Code is Correct' : 'Enter Code sent to your Email')} arrow placement="top">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText style={{ backgroundColor: (code === 'right' ? 'lightgreen' : 'white'), color: (code === 'right' ? 'black' : '') }}>
                                                    <i className="ni ni-key-25" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                placeholder="Verification Code"
                                                type="text"
                                                autoComplete=""
                                                onChange={handleChangeU}
                                            />
                                        </InputGroup>
                                    </Tooltip>
                                </FormGroup>
                            </Col>
                            <Col className="" sm={12} lg={12}>
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative" style={{ backgroundColor: 'white' }}>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-lock-circle-open" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Enter New Password"
                                            type={showpass1 ? "text" : "password"}
                                            autoComplete="new-password"
                                            onChange={handleChangeP1}
                                            onKeyDown={handleKeypress}
                                            style={{ marginTop: '2px' }}
                                        />
                                        <InputGroupAddon addonType="append" style={{ backgroundColor: 'white' }}>
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword1}
                                                style={{ color: '#acb5bc', backgroundColor: 'transparent' }}
                                                disableRipple
                                            >
                                                {showpass1 ? <Visibility style={{ width: 18 }} /> : <VisibilityOff style={{ width: 18 }} />}
                                            </IconButton>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col className="" sm={12} lg={12}>
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative" style={{ backgroundColor: 'white' }}>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-lock-circle-open" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Re-enter New Password"
                                            type={showpass2 ? "text" : "password"}
                                            autoComplete="new-password"
                                            onChange={handleChangeP2}
                                            onKeyDown={handleKeypress}
                                            style={{ marginTop: '2px' }}
                                        />
                                        <InputGroupAddon addonType="append" style={{ backgroundColor: 'white' }}>
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword2}
                                                style={{ color: '#acb5bc', backgroundColor: 'transparent' }}
                                                disableRipple
                                            >
                                                {showpass2 ? <Visibility style={{ width: 18 }} /> : <VisibilityOff style={{ width: 18 }} />}
                                            </IconButton>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                            <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                        </Snackbar>
                        <div className="custom-control custom-control-alternative custom-checkbox">
                        </div>
                        <div className="text-center">
                            <Button className="my-0" color="primary" type="button"
                                onClick={loginPageHandler}>
                                Go
                                </Button>
                        </div>
                    </CardBody>
                </Card>
                <Row className="mt-3">
                    <Col xs="6">
                        <a
                            className="text-light"
                            href="login"
                        >
                            <small>Login</small>
                        </a>
                    </Col>
                    <Col className="text-right" xs="6">
                        <a
                            className="text-light"
                            href="signup"
                        >
                            <small>Create new account</small>
                        </a>
                    </Col>
                </Row>
            </Col>
        </>
    );
};

// export default Login;

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
    }
}

export default connect(mapStateToProps)(Login);